import { brandLogos } from '../../../utils/images';

export default function LogoWall() {
  // Create 8 sets of logos for smooth infinite scrolling
  // With 13 logos × 8 sets = 104 total logos
  const allLogos = [...Array(8)].flatMap(() => brandLogos);

  return (
    <section className="py-12 bg-white">
      <div className="w-full overflow-hidden">
        <div className="relative">
          {/* Gradient overlays for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10"/>
          <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10"/>

          {/* Scrolling logo container with infinite loop */}
          <div className="flex animate-scroll hover:pause">
            <div className="flex-shrink-0 flex items-center space-x-16 px-8">
              {allLogos.map((logoUrl, index) => (
                <div key={`logo-${index}`} className="flex-shrink-0 w-40 h-24 bg-white rounded-xl flex items-center justify-center">
                  <img
                    src={logoUrl}
                    alt={`Brand Logo ${(index % brandLogos.length) + 1}`}
                    className="max-h-16 max-w-32 object-contain"
                    onError={(e) => {
                      // If image fails to load, hide it
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}